<template>
    <div class="h-full">
        <ai-grid-edit v-if="isDataLoaded" ref="gridRef" :meta="meta" :args="args" />
    </div>
</template>

<script setup>
import AiGridEdit from '@/components/ai-grid-edit/ai-grid-edit.vue';
import { /*computed,*/ onMounted, ref, reactive } from 'vue';
import { useRoute } from 'vue-router';
//import { getArea } from '@/service/counteragent-service';

const gridRef = ref();
//const gridInstance = ref();
const isDataLoaded = ref(false);
/*const area = ref([]);
const areaComp = computed(() => area.value);*/
const refreshDicts = async () => {
    /*const data = await getArea();
    if (data && data.result) {
        area.value = data.data;
    }*/
};

onMounted(async () => {
    await refreshDicts();
    isDataLoaded.value = true;
    //gridRef.value.onInitNewRow = InitKodp
    //gridInstance.value = gridRef.value?.gridInstance;
    //meta.api.select = `http://${process.env.VUE_APP_HOST}:${process.env.VUE_APP_PORT}/counteragent./customer/card/widget/notebook/get`;
});

const route = useRoute();

const meta = reactive({
    keyExpr: 'id',
    viewId: 'WidgetPayerNotebookGE',
    focusedRowEnabled: true,
    api: {
        select: 'counteragent./customer/card/widget/notebook/get',
        save: 'counteragent./customer/card/widget/notebook/save',
    },
    columns: [
        {
            dataField: 'id',
            caption: 'ID',
            visible: false,
            allowEditing: false,
            dataType: 'number',
        },
        {
            dataField: 'txt',
            caption: 'Текст записной книжки',
            dataType: 'string',
        },
        {
            dataField: 'dat',
            caption: 'Дата ввода',
            dataType: 'string',
            allowEditing: false,
        },
        {
            dataField: 'kod_area',
            caption: 'Область применения',
            /*readOnly: true,
            lookup: {
                dataSource: areaComp,
                displayExpr: 'name',
                valueExpr: 'kod_area'
            }*/
            editor: { type: 'ai-drop-down', text: 'area_name' },
            component: {
                path: 'components/ai-grid-ro/ai-grid-ro.vue',
                text: 'name',
                meta: {
                    keyExpr: 'kod_area',
                    columns: [
                        { caption: 'kod_area', visible: false, dataField: 'kod_area' },
                        { caption: 'Область', dataField: 'name' },
                    ],
                    api: { select: 'meta./meta/ai-grid-ro-select/get' },
                },
                args: {
                    meta_args: { select: 'payer.hf_get_dictionary' },
                    select_args: { schema: 'payer', table: 'rk_area', where: 'true', order: 'name' },
                },
            },
        },
    ],
});

const args = { select: { kodp: route.params.id }, save: { kodp: route.params.id } };
</script>
